import PageHeader from "@/components/site/PageHeader";
import TestimonialsMarquee from "@/components/sections/TestimonialsMarquee";
import ContactForm from "@/components/sections/ContactForm";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useI18n } from "@/i18n/i18n";

export default function Testimonials() {
  const { tr } = useI18n();
  return (
    <div data-testid="testimonials-page">
      <PageHeader
        overline={tr.testimonials_page.overline}
        title={tr.testimonials_page.title}
        subtitle={tr.testimonials_page.subtitle}
      />

      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {tr.testimonials_page.stories.map((t, i) => (
              <motion.article
                key={t.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: i * 0.05 }}
                className="mc-card p-10 flex flex-col"
                data-testid={`testimonial-full-${i}`}
              >
                <div className="flex items-center justify-between">
                  <Quote className="h-8 w-8 text-[color:var(--mc-cyan)] opacity-80" />
                  <span className="text-xs uppercase tracking-wider font-semibold text-[color:var(--mc-gold)] bg-[color:var(--mc-gold)]/10 border border-[color:var(--mc-gold)]/30 px-3 py-1.5 rounded-full">
                    {t.result}
                  </span>
                </div>
                <p className="mt-6 text-white/90 leading-relaxed text-lg">“{t.text}”</p>
                <div className="mt-8 flex items-center justify-between pt-6 border-t border-white/10">
                  <div>
                    <p className="font-heading font-semibold text-white">{t.name}</p>
                    <p className="text-sm text-white/60">{t.location}</p>
                  </div>
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-[color:var(--mc-gold)] text-[color:var(--mc-gold)]" />
                    ))}
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <TestimonialsMarquee />
      <ContactForm />
    </div>
  );
}
